import BasicCardContainer from "../../Componant/BonusUI/BasicCard";

const BasicCard = () => {
  return (
    <div className="page-body">
      <BasicCardContainer />
    </div>
  );
};

export default BasicCard;
